// Görsel URL'leri veritabanından ham geliyor: tam boyut, dönüşümsüz.
// Buradaki yardımcı, tanıdığı CDN'lerde URL'e genişlik/kalite ekleyerek
// küçültülmüş sürümü ister. Tanımadığı adresler olduğu gibi döner.

const CLOUDINARY_UPLOAD = '/image/upload/';

const cloudinary = (url, width) => {
  const [prefix, rest] = url.split(CLOUDINARY_UPLOAD);

  // Zaten bir dönüşüm varsa (ör. f_auto,...) tekrar ekleme.
  if (/^[a-z]{1,3}_/.test(rest)) return url;

  return `${prefix}${CLOUDINARY_UPLOAD}f_auto,q_auto,w_${width},c_fill/${rest}`;
};

const unsplash = (url, width) => {
  try {
    const parsed = new URL(url);
    parsed.searchParams.set('w', String(width));
    parsed.searchParams.set('auto', 'format');
    if (!parsed.searchParams.has('q')) parsed.searchParams.set('q', '70');
    return parsed.toString();
  } catch {
    return url;
  }
};

export const optimizedImage = (url, width = 800) => {
  if (!url || typeof url !== 'string') return url;

  if (url.includes('res.cloudinary.com') && url.includes(CLOUDINARY_UPLOAD)) {
    return cloudinary(url, width);
  }

  if (url.includes('images.unsplash.com') || url.includes('plus.unsplash.com')) {
    return unsplash(url, width);
  }

  return url;
};

// Eski isim; Cloudinary'ye özel çağrılar bozulmasın diye duruyor.
export const cloudinaryImage = optimizedImage;

export default optimizedImage;
